import React, {useState, useEffect} from "react";
import {formatDate} from '../helpers/util';
import Valper from "./Valper";
import Foreldre from "./Foreldre";
import icons from "../helpers/icons";

const Kull = (props) => {
    const kull = props.kull;
    let expandAll = props.expandAll;
    const showRase = props.showRase;
    const [showKullData, setShowKullData] = useState(false);

    useEffect(() => {
        if (expandAll && !showKullData && props.collapseAll)
            setShowKullData(true);
        else if (!expandAll && showKullData && props.collapseAll)
            {setShowKullData(false);
            props.setCollapseAll(false)}
    },[expandAll,showKullData,props]);

    const kullData = (
        <div>
            {(showKullData) &&
            <ul>
                <li>
                    <Valper valper={kull.valper}/>
                    <Foreldre far={kull.far} mor={kull.mor} labelFar="FAR" labelMor="MOR"/>
                </li>
            </ul>
            }
        </div>
    );

    const toggleKullData = () => {
        setShowKullData(!showKullData);
        if (expandAll){
        props.setExpandAll(false);
        props.setCollapseAll(false);
        }
    };

    function showSkullToggle() {
        return showKullData;

    }

    return (
        <div>
            <div className="kuld">
                <ul className="vertical menu accordion-menu">
                    <li>
                        <button onClick={toggleKullData}>
                            <ul className="menu-line">
                                <li>{formatDate(kull.foedt, true)}</li>
                                <li style={{"textAlign":"left"}}>{kull.valper.length} Hvalpe {showRase && kull.mor.rase !== null ? kull.mor.rase.navn : '' }
                                    {kull.omregistrering ? <em>({kull.omregistreringTypeStreng})</em> : <>&nbsp;</> }</li>
                                <li><img src={icons.acd} alt="" data-open={showKullData}/></li>
                            </ul>
                        </button>
                        {kullData}
                    </li>
                </ul>
            </div>

        </div>
    );
};

export default Kull;
